import { render } from "./PdfPreviewLayout.vue?vue&type=template&id=3284a878"
import script from "./PdfPreviewLayout.vue?vue&type=script&lang=js"
export * from "./PdfPreviewLayout.vue?vue&type=script&lang=js"

import "./PdfPreviewLayout.vue?vue&type=style&index=0&id=3284a878&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__